"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".callout_60f83d20 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_60f83d20 .ms-Suggestions{width:300px}\n" }]);
exports.callout = "callout_60f83d20";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/FloatingPicker/BaseFloatingPicker.scss.js
// module id = 998
// module chunks = 0